module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chat-red-9a79428c8eb1a0d7cf146d2aa2b09760.svg";